import { render, staticRenderFns } from "./VxSidebarGroup.vue?vue&type=template&id=02d9fa7a&"
import script from "./VxSidebarGroup.vue?vue&type=script&lang=js&"
export * from "./VxSidebarGroup.vue?vue&type=script&lang=js&"
import style0 from "./VxSidebarGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports